<template>
    <div
        :class="[ { 'border-l-4 pl-4 -ml-5' : border }, border && isOpen ? 'border-primary' : 'border-transparent' ]"
        class="transition-slow"
    >
        <div
            :class="{ 'text-primary' : isOpen }"
            class="cursor-pointer select-none hover:opacity-75 transition-fast"
            @click="$emit('open', index)"
        >
            <slot name="trigger" />
        </div>
        <div
            ref="content"
            class="content"
        >
            <div ref="content2">
                <slot name="content" />
            </div>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        index: {
            type: Number,
            required: true,
        },
        openIndex: {
            type: Number,
            default: null,
        },
        border: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        isOpen() {
            return this.index === this.openIndex;
        },
    },

    watch: {
        isOpen(isOpen) {
            if (isOpen) {
                this.$refs.content.style.height = `${this.$refs.content2.scrollHeight}px`;
            } else {
                this.$refs.content.style.height = 0;
            }
        },
    },

    mounted() {
        window.addEventListener('resize', this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },

    methods: {
        onResize() {
            if (this.isOpen) {
                this.$refs.content.style.height = `${this.$refs.content2.scrollHeight}px`;
            }
        },
    },

};
</script>

<style lang="scss" scoped>
.content {
    @apply overflow-hidden transition-slow;
    height: 0;
}
</style>
